import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/dashboard/:organizationId",
    name: "Dashboard",
    component: () => import("@/views/Dashboard.vue"),
  },
  {
    path: "/subscription/",
    name: "Subscription",
    component: () => import("@/views/Subscription.vue"),
  },
  {
    path: "/translator/:translatorId",
    name: "TranslatorDashboard",
    component: () => import("@/views/TranslatorDashboard.vue"),
  },
  {
    path: "/login/",
    name: "Login",
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/register/:target?/:reroute?",
    name: "Register",
    component: () => import("@/views/Registration.vue"),
  },
  {
    path: "/event/:organizationId/:eventId/:encryptionPw/:eventPw",
    name: "Event",
    component: () => import("@/views/Event.vue"),
  },
  {
    path: "/embed/:organizationId/:eventId/:encryptionPw/:eventPw",
    name: "Embed",
    component: () => import("@/views/Embed.vue"),
  },
  {
    path: "/viewer-live/:organizationId/:eventId/:encryptionPw/:eventPw",
    name: "ViewerLivestream",
    component: () => import("@/views/ViewerLive.vue"),
  },
  {
    path: "/live/:organizationId/:eventId/:encryptionPw/:eventPw",
    name: "Live",
    component: () => import("@/views/Live.vue"),
  },
  {
    path: "/demo-livestream",
    name: "DemoLiveStream",
    component: () => import("@/views/DemoLiveStreamView.vue"),
  },
  {
    path: "/invite/:target",
    name: "Invite",
    component: () => import("@/views/Invite.vue"),
  },
  {
    path: "/proxydashboard/:organizationId/:eventId?",
    name: "ProxyDashboard",
    component: () => import("@/views/ProxyDashboard.vue"),
  },
  {
    path: "/eventwizard/:organizationId/:eventId?",
    name: "EventWizard",
    component: () => import("@/views/EventWizard.vue"),
  },
  {
    path: "/eventwizardlimited/:organizationId/:eventId",
    name: "EventWizardLimited",
    component: () => import("@/views/EventWizardLimited.vue"),
  },
  {
    path: "/overview/:organizationId/:eventId",
    name: "EventOverview",
    component: () => import("@/views/EventOverview.vue"),
  },
  {
    path: "/admin",
    name: "PlatformDashboard",
    component: () => import("@/views/PlatformDashboard.vue"),
  },
  {
    path: "/resetpassword",
    name: "ResetPassword",
    component: () => import("@/views/ResetPassword.vue"),
  },
  {
    path: "/account",
    name: "UserAccount",
    component: () => import("@/views/UserAccount.vue"),
  },
  {
    path: "/polling/create/:surveyId?/:organizationId?",
    name: "CreateSurvey",
    component: () => import("@/views/SurveyCreator.vue"),
  },
  {
    path: "/polling/participate/:surveyCode?",
    name: "Polling",
    component: () => import("@/views/SurveyParticipate.vue"),
  },
  {
    path: "/polling/admin/:surveyCode/:moderationPw?",
    name: "AdminSurvey",
    component: () => import("@/views/SurveyAdmin.vue"),
  },
  {
    path: "/polling/presentation/:surveyCode/:moderationPw?",
    name: "SurveyPresentation",
    component: () => import("@/views/SurveyPresentation.vue"),
  },
  {
    path: "/polling/embed/:surveyCode",
    name: "SurveyEmbed",
    component: () => import("@/views/SurveyEmbed.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
